import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-nav">
        <a href="#home">Home</a>
        <a href="#what-is-ai-coo">What is AI COO?</a>
        <a href="#feedback">Feedback & Reviews</a>
        <a href="#pricing">Pricing</a>
        <a href="#dashboard">Dashboard</a>
        <a href="#contact">Contact</a>
      </div>
      <div className="footer-copy">&copy; 2024 AI COO. All rights reserved.</div>
    </footer>
  );
} 